export const TAB_NAMES = {
  profile: 'Profile',
  transactions: 'Scanning',
  alerts: 'Alerts Settings',
  gopro: 'GoPRO Cloud Settings'
};

export const TAB_HASH = {
  profile: '#profile',
  transactions: '#scanning',
  alerts: '#alerts',
  gopro: '#gopro'
};

export const TABS = [
  { name: TAB_NAMES.profile, icon: 'Settings', hash: TAB_HASH.profile },
  { name: TAB_NAMES.alerts, icon: 'Settings', hash: TAB_HASH.alerts },
  { name: TAB_NAMES.transactions, icon: 'Document', hash: TAB_HASH.transactions },
  { name: TAB_NAMES.gopro, icon: 'Settings', hash: TAB_HASH.gopro }
];
